import {
  formatInvoiceValue,
  getCurrencySymbol,
  useGetStudentInvoicesBalanceQuery,
} from '@/entities/Invoices';
import { Section } from '@/shared/ui/Section';

const TILES = [
  { key: 'totalInvoiced', label: 'Total invoiced' },
  { key: 'totalPaid', label: 'Paid' },
  { key: 'outstanding', label: 'Outstanding' },
] as const;

export const InvoiceBalanceTiles = () => {
  const { data, isError } = useGetStudentInvoicesBalanceQuery();

  if (!data || isError) return null;

  const symbol = getCurrencySymbol(data.currency);

  return (
    <div className="flex w-full flex-col gap-3">
      {TILES.map((tile) => {
        const label = symbol ? `${tile.label}, ${symbol}` : tile.label;

        return (
          <Section
            key={tile.key}
            className="w-full rounded-[16px] bg-white px-6 py-4 shadow-sm"
          >
            <p className="text-sm font-medium text-grey-secondary">{label}</p>
            <p className="text-[32px] font-medium text-black-headline">
              {formatInvoiceValue(data[tile.key])}
            </p>
          </Section>
        );
      })}
    </div>
  );
};
